<template>
<div class="CommentsList">
  <CommentsListItem 
    class="CommentsList__item"
    v-for="(comment, index) in comments"
    :key="comment.id + '_' + index"
    :comment="comment"
    @submitComment="submitComment($event)" />
</div>
</template>
<script>
  import CommentsListItem from './CommentsListItem';

  export default {
    name: 'CommentsList',
    components: {
      CommentsListItem
    },
    props: {
      comments: {
        type: Array,
        required: true
      }
    },
    methods: {
      submitComment(comment) {
        this.$emit('submitComment', comment);
      }
    }
  }
</script>
<style lang="scss">
  .CommentsList {
    &__item {
    }
  }
</style>
